import Scriba from 'react-scriba';

export class DataSociete {

    static _chargementSociete(idSociete) {
        const objet = { "idSociete": idSociete };
        const url = "api/Get/GetSociete";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementSocietes(filtres, sortedColumn, isSortedDescending) {
        const objet = { filtres, sortedColumn, isSortedDescending };
        const url = "api/Liste/ListeDesSocietes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesSocietes(doitInclureEiffage, doitInclureExterne) {
        let objet = { doitInclureEiffage, doitInclureExterne };
        const url = "api/Get/GetLesSocietes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesSocietesParTypeMandat(idTypeMandat) {
        let objet = { idTypeMandat };
        const url = "api/Get/GetLesSocietesParTypeMandat";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesSocietesDontAuMoinsUnMandatAppartientAmonPerimetre(listeIdContacts, doitInclureSocietesSansMandat, doitInclureSocietesSansCompte) {
        let objet = {
            "doitInclureSocietesSansMandat": doitInclureSocietesSansMandat || false,
            "doitInclureSocietesSansCompte": doitInclureSocietesSansCompte || false
        };
        if (listeIdContacts != null & listeIdContacts != undefined) {
            objet.listeIdContacts = listeIdContacts;
        }

        const url = "api/Get/GetLesSocietesDontAuMoinsUnMandatAppartientAmonPerimetre";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesSocietesDontAuMoinsUnMandatEnglobeLeLotCommercial(idLotCommercial, idOperation) {
        let objet = {
            "idLotCommercial": idLotCommercial,
            "idOperation": idOperation
        };

        const url = "api/Get/GetLesSocietesDontAuMoinsUnMandatEnglobeLeLotCommercial";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesSocietesDontAuMoinsUnMandatEnglobeLOperation(idOperation, avecMandatSurLotDeLOperation) {
        let objet = {
            idOperation,
            avecMandatSurLotDeLOperation
        };

        const url = "api/Get/GetLesSocietesDontAuMoinsUnMandatEnglobeLOperation";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesSocietesDontAuMoinsUnMandatEnglobeLaRegion(idRegion) {
        let objet = {
            "idRegion": idRegion
        };

        const url = "api/Get/GetLesSocietesDontAuMoinsUnMandatEnglobeLaRegion";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesSocietesDontAuMoinsUnMandatEnglobeLAgence(idRegion, idAgence) {
        let objet = {
            "idRegion": idRegion,
            "idAgence": idAgence
        };

        const url = "api/Get/GetLesSocietesDontAuMoinsUnMandatEnglobeLAgence";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementSociete(societe) {
        const url = "api/MAJDonnees/EnregistrementSociete";
        const paramPost = Scriba.fetch().createParameterPost(societe);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _onMiseAJourParametresPush(societe) {
        const url = "api/MAJDonnees/MiseAJourParametresPush";
        const paramPost = Scriba.fetch().createParameterPost(societe);
        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionSociete(idSociete) {
        const objet = { "idSociete": idSociete };
        const url = "api/MAJDonnees/SuppressionSociete";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    }
}